import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from "react";
import { Channel } from "./Channel";
import PublicRoomContext from "../../../../application/Context/PublicRoomContext";
import { LoadingThread } from "../../shared-components/Loading/LoadingThread";
export var ChannelsList = function () {
    var _a = React.useContext(PublicRoomContext), channels = _a.channels, channelsLoading = _a.channelsLoading;
    return (_jsxs("ul", { className: "pr-tabs-list", children: [channelsLoading && _jsx(LoadingThread, {}), channels &&
                channels.map(function (chanel) { return _jsx(Channel, { id: chanel.id, chanel: chanel }, chanel.id); })] }));
};
